import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { UserState } from 'src/app/states/user-state/user.state';
import { RightsService } from '../../../services/rights.service';
import { UnsavedChangesService } from '../../../services/unsavedChanges.service';
import { UserRoles } from '../../constants/userRoles';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @Select(UserState.getUserName)
  public userName$!: Observable<string>;

  @Select(UserState.getUserDetails)
  public userRole$!: Observable<string>;
  
  public title = 'Labconnector';
  public unassignedRole = UserRoles.roleUnassigned;

  public constructor(
    public accessService: RightsService,
    private authService: AuthService,
    private unsavedChangesService: UnsavedChangesService
  ) {}

  public logout(): void {
    if (this.unsavedChangesService.shouldContinue()) {
      this.unsavedChangesService.resetComponent();
      this.authService.logout();
    }
  }
}
